import React from "react";

const ContactUs = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
      <p className="mb-4">
        If you have any questions, feel free to reach out to us.
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Email: support@codeblaze.net</li>
        <li>Phone: +91 99453 90672</li>
        <li>
          Address: #129, Syed Aslam Manzil, 1st Main, 3rd Cross, 3rd Block,
          Bangalore – 560039, District: Bengaluru (Urban), State: Karnataka,
          India. Mobile: +91 99453 90672 Email: codeblazee@gmail.com
        </li>
      </ul>
    </div>
  );
};

export default ContactUs;
